import { MatDialogConfig } from '@angular/material/dialog';
import { CREATE_ORDER_PANEL_CLASS } from 'src/features/service-order/create-order/ui/create-order/create-order-dialog.config';
import { OrderPdfDialogData } from './order-pdf-dialog.component';

export function buildOrderPdfDialogConfig(
  data: OrderPdfDialogData
): MatDialogConfig<OrderPdfDialogData> {
  return {
    width: 'min(1120px, 96vw)',
    maxWidth: '96vw',
    height: 'min(92vh, 900px)',
    maxHeight: '92vh',
    panelClass: [CREATE_ORDER_PANEL_CLASS, 'order-pdf-dialog-panel'],
    autoFocus: false,
    data
  };
}
